import React, { Component } from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import styles from './Layout.module.css';
export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <Container tag="main" className={styles.fullWidthContainer}>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
